import React from "react";

/**
 * Toggle chọn app hiển thị — dùng CHUNG cho Quản lí Cuộc Thi + Chủ đề Beat.
 *
 * Kiểu pill bo tròn hết + đường kẻ chân chạy full ngang (theo ảnh mẫu). Tab ĐANG chọn: nền xanh
 * #1677ff + chữ trắng + gạch chân xanh. Tab KHÔNG chọn: chữ xám, nền trong suốt (hover hiện xanh nhạt).
 *
 * @param {'YOKARA'|'IKARA'|'YOSING'} value  App đang chọn.
 * @param {(next:'YOKARA'|'IKARA'|'YOSING')=>void} onChange  Gọi khi bấm 1 tab.
 */
export default function AppFilterToggle({ value = "YOKARA", onChange = () => {}, showYosing = false }) {
  const brands = [
    { key: "YOKARA", label: "Yokara", cls: "yokara" },
    { key: "IKARA", label: "iKara", cls: "ikara" },
  ];
  if (showYosing) {
    brands.push({ key: "YOSING", label: "Yosing", cls: "yosing" });
  }

  return (
    <div className="brand-selector">
      <div className="brand-tabs">
        {brands.map((brand) => {
          const isActive = value === brand.key;

          return (
            <button
              key={brand.key}
              type="button"
              className={`brand-tab ${brand.cls} ${isActive ? "active" : ""}`}
              onClick={() => onChange(brand.key)}
              aria-selected={isActive}
            >
              {brand.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}

/* =========================
   CSS (inject 1 lần)
========================= */

const styleId = "yokara-ikara-brand-selector-style";

if (typeof document !== "undefined" && !document.getElementById(styleId)) {
  const style = document.createElement("style");

  style.id = styleId;

  style.textContent = `
    .brand-selector {
      width: 100%;
      display: flex;
      justify-content: center;
      margin: 10px 0 20px;

      /* Đường kẻ chân chạy full ngang trang */
      border-bottom: 1px solid #e5e7eb;
    }

    .brand-tabs {
      display: flex;
      align-items: flex-end;
      justify-content: center;
      gap: 22px;

      /* Nhấc pill lên khỏi đường kẻ chân cho thoáng */
      margin-bottom: 5px;
    }

    .brand-tab {
      position: relative;

      min-width: 176px;
      height: 50px;

      padding: 0 32px;

      border: none;
      border-radius: 26px;

      background: transparent;

      color: #344054;

      font-size: 20px;
      font-weight: 600;

      cursor: pointer;

      transition:
        color 0.2s ease,
        background-color 0.2s ease;
    }

    /* Hover cho tab CHƯA chọn */
    .brand-tab:not(.active):hover {
      color: #1677ff;
      background: #f5f9ff;
    }

    /* Tab đang được chọn: nền xanh + chữ trắng */
    .brand-tab.active {
      color: #ffffff;
      background: #1677ff;
    }

    /* Gạch chân tab đang chọn */
    .brand-tab.active::after {
      content: "";

      position: absolute;

      left: 0;
      right: 0;
      bottom: -1px;

      height: 3px;

      background: #1677ff;

      border-radius: 3px 3px 0 0;
    }

    /* Responsive */
    @media (max-width: 600px) {
      .brand-tabs {
        min-width: 280px;
        gap: 8px;
      }

      .brand-tab {
        min-width: 130px;
        height: 46px;

        padding: 0 20px;

        font-size: 17px;
      }
    }
  `;

  document.head.appendChild(style);
}
